/** The account collection page's own catalogue. */

import { defineCatalogue } from '../../../../i18n';

export const trackingEditorCatalogue = defineCatalogue(
  {
    heading: 'Coleta da conta',
    lead: 'A conta coleta pelo perfil escolhido: os períodos, as frequências e as cores vêm dele.',
    profile: 'Perfil de coleta',
    editProfile: 'Editar este perfil',
    save: 'Salvar',
    saved: 'Perfil da conta salvo.',
    loading: 'Carregando a coleta da conta…',
  },
  {
    heading: 'Account collection',
    lead: 'The account collects through the chosen profile: its periods, frequencies and colours come from it.',
    profile: 'Collection profile',
    editProfile: 'Edit this profile',
    save: 'Save',
    saved: 'Account profile saved.',
    loading: 'Loading the account’s collection…',
  },
);

export const trt = trackingEditorCatalogue.t;
